import { useDispatch } from "react-redux";

import { EnvelopeRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const LeadFromMailerActivity = ({ activity, onReadChange }) => {
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#FAE6F0] tw-text-[#A31D61]" Icon={EnvelopeRegularV6}>
            New Lead From Mailer
          </CategoryContainer>
        }
        personName={`${activity.data?.subjectFirstName} ${activity.data?.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        {activity.data.campaignTitle && <DataField label="Campaign" data={activity.data.campaignTitle} />}
        {activity.data.address && <DataField label="Address" data={activity.data.address} />}
        {activity.data.subjectEmail && <DataField label="Email" data={activity.data.subjectEmail} />}
        {activity.data.subjectPhoneNumber && (
          <DataField label="Phone" data={activity.data.subjectPhoneNumber} />
        )}
        {activity.data.source && <DataField label="Source" data={activity.data.source} />}
      </div>
      <ActivityBtns
        callHandlr={() => {
          if (activity.data?.personUuid) {
            dispatch(
              setCallParams({
                leadUuids: [activity.data?.personUuid],
                callSource: "Lead From Mailer Activity",
              }),
            );
          }
        }}
        containerClassName="!tw-mt-8px"
      />
    </ActivityContainer>
  );
};

export default LeadFromMailerActivity;

LeadFromMailerActivity.propTypes = {
  ...activityCommonPropTypes,
};

LeadFromMailerActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
